module.exports = __webpack_public_path__ + "static/media/icon-devolucao.8ed3a991.svg";